/** Base interface for all external VMS integrations. Extend per vendor. */
export interface ExternalVmsBase {
  vendor: string;
}

export interface OrchidCamera {
  id: number;
  name?: string;
  streamId: number;
}

export interface OrchidExternalVms extends ExternalVmsBase {
  vendor: 'orchid';
  baseUrl: string;
  orchidId: string;
  cameras: OrchidCamera[];
  hybridLink?: string;
  timestamp?: number;
}

export type ExternalVms = OrchidExternalVms;

function isValidOrchidCamera(cam: unknown): cam is OrchidCamera {
  if (!cam || typeof cam !== 'object') return false;
  const c = cam as Record<string, unknown>;
  return typeof c.id === 'number' && typeof c.streamId === 'number';
}

/**
 * Parse and validate the raw externalVms value from event.details.
 * Returns a typed ExternalVms only if the vendor field is recognized
 * and all required fields pass validation. All vendor checks happen
 * here so consumers don't need to validate independently.
 */
export function parseExternalVms(raw: unknown): ExternalVms | undefined {
  if (!raw || typeof raw !== 'object' || !('vendor' in raw)) return undefined;
  const obj = raw as Record<string, unknown>;
  switch (obj.vendor) {
    case 'orchid':
      if (
        typeof obj.baseUrl !== 'string' ||
        typeof obj.orchidId !== 'string' ||
        !Array.isArray(obj.cameras) ||
        !obj.cameras.every(isValidOrchidCamera)
      )
        return undefined;
      return raw as OrchidExternalVms;
    default:
      return undefined;
  }
}
